import { ReviewEntryStatus } from '../enums/reviewEntryStatus'
import { isReviewEntryProcessingStatus } from './isReviewEntryProcessingStatus'

const hasApprovedStatus = (status: string): boolean =>
  /\bapproved\b/.test(status) && !/\bunapproved\b/.test(status) && !/\bdisapproved\b/.test(status)

const hasReviewedStatus = (status: string): boolean =>
  /\breviewed\b/.test(status) && !/\bnot[_-]reviewed\b/.test(status)

export const isToValidateStatus = (status: string | undefined): boolean => {
  const normalizedStatus = status?.toLowerCase() ?? ''

  if (isReviewEntryProcessingStatus(status)) {
    return false
  }

  if (
    normalizedStatus === ReviewEntryStatus.Validated ||
    normalizedStatus === ReviewEntryStatus.Written ||
    hasReviewedStatus(normalizedStatus) ||
    hasApprovedStatus(normalizedStatus)
  ) {
    return false
  }

  return true
}
